import React, { useEffect, useState } from 'react';
import { Row, Col, Divider, Button } from 'antd';
import { css } from '@emotion/core';
import axios from 'axios';
import {
  TrackingInfoStatusStep,
  TimelineSpacer,
  Container,
  Title,
  SubTitle,
  AddressTitle,
  AddressContent,
  StatusContainer,
  FlexContainer,
} from '../components/Orders/TrackingInfo/styled';
import Spinner from '../components/common/spinner';
import Page404 from './404.js';

const getExternalOrdersURL = code => {
  if (process.env.REACT_APP_ENV === 'prod')
    return `https://api-prod.triplemars.com/api/autopurchase/v1/ExternalOrders/tracking-details-user/${code}`;
  return `https://api-dev.triplemars.com/api/autopurchase/v1/ExternalOrders/tracking-details-user/${code}`;
};

const getInternalOrdersURL = code => {
  if (process.env.REACT_APP_ENV === 'prod')
    return `https://api-prod.triplemars.com/api/order/v1/Orders/tracking-details-user/${code}`;
  return `https://api-dev.triplemars.com/api/order/v1/Orders/tracking-details-user/${code}`;
};

const TrackingInfoPage = ({
  trackingId,
  trackingHeader,
  trackingCarrier,
  trackingAddress,
  trackingEvents,
}) => {
  const isLoggedIn = document.cookie.split(' ').find(st => st.slice(0, 15) === 'tm-access-token');
  return (
    <>
      <FlexContainer>
        <Container>
          <Row>
            <Title>
              {`Order ${trackingId ?? 'N/A'}`}
              <SubTitle>
                {trackingCarrier ?? 'N/A'} - {trackingHeader ?? 'N/A'}
                <Divider />
              </SubTitle>
            </Title>
            <Row>
              <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
                <AddressTitle>
                  Address
                  <div
                    css={css`
                      margin-bottom: 10px;
                    `}
                  >
                    {trackingAddress &&
                      trackingAddress.map(item => (
                        <AddressContent key={`address-content-${item}`}>{item}</AddressContent>
                      ))}
                  </div>
                </AddressTitle>
              </Col>

              <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
                <StatusContainer>
                  <TrackingInfoStatusStep
                    index={0}
                    currentStep={trackingEvents?.Ordered ?? false}
                    title="Ordered"
                  />
                  <TimelineSpacer width="100px" green={trackingEvents?.Ordered ?? false} />
                  <TrackingInfoStatusStep
                    index={1}
                    currentStep={trackingEvents?.Shipped ?? false}
                    title="Shipped"
                  />
                  <TimelineSpacer width="100px" green={trackingEvents?.Shipped ?? false} />
                  <TrackingInfoStatusStep
                    index={2}
                    currentStep={trackingEvents?.['Out for delivery'] ?? false}
                    title="Out for delivery"
                  />
                  <TimelineSpacer
                    width="100px"
                    green={trackingEvents?.['Out for delivery'] ?? false}
                  />
                  <TrackingInfoStatusStep
                    index={3}
                    currentStep={trackingEvents?.Delivered ?? false}
                    title="Delivered"
                  />
                </StatusContainer>
              </Col>
            </Row>
          </Row>
        </Container>
      </FlexContainer>
      <FlexContainer>
        {isLoggedIn && (
          <Button type="primary" onClick={() => history.back()}>
            Go Back
          </Button>
        )}
      </FlexContainer>
    </>
  );
};

const NoTrackingInfoPage = () => {
  return (
    <FlexContainer>
      <Title>There is no tracking info for this order.</Title>
    </FlexContainer>
  );
};

const getErrorPage = (invalidPath, noTrackingInfo) => {
  if (invalidPath) return <Page404 />;
  if (noTrackingInfo) return NoTrackingInfoPage();
  return <Spinner />;
};

const TrackingInfo = ({ params: { code } }) => {
  const [trackingInfo, setTrackingInfo] = useState();
  const [invalidPath, setInvalidPath] = useState(false);
  const [noTrackingInfo, setNoTrackingInfo] = useState(false);

  useEffect(() => {
    const isOnExternal = window.location.pathname.includes('externalOrders/trackingInfo');
    const url = isOnExternal ? getExternalOrdersURL(code) : getInternalOrdersURL(code);
    axios
      .get(url)
      .then(({ data }) => setTrackingInfo(data))
      .catch(err => {
        try {
          const errorMessage = err.response?.data;
          if (errorMessage.title === 'One or more validation errors occurred.')
            return setInvalidPath(true);
          if (errorMessage.includes('Could not find')) return setNoTrackingInfo(true);
          return setInvalidPath(true);
        } catch (error) {
          return setInvalidPath(true);
        }
      });
  }, []);

  return (
    <>{trackingInfo ? TrackingInfoPage(trackingInfo) : getErrorPage(invalidPath, noTrackingInfo)}</>
  );
};

export default TrackingInfo;
